module.exports = __webpack_public_path__ + "static/media/unchecked.2b369fd2.svg";